/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-15 16:21:40
 *
 *******************************************************/

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Grid, TextStyle } from '@shopify/polaris';
import { RenderSelect2 } from 'src/components/views/common/forms/render-select-2-v2';
import { RenderRadioButtonItemV2 } from 'src/components/views/common/forms/render-radio-button-item-v2';
import { DropdownIndicator, styles } from '../../form/react-select-style';
import {
  MAIN_LAYOUT_VALUE,
  MAIN_LAYOUT_OPTIONS,
  SUB_LAYOUT_OPTIONS
} from 'src/constants/theme-settings.js';
import { capitalizeFirstLetter } from 'src/helpers';

type Props = {
  formValues: any,
  prefix: string,
  updateField: (field: string, value: any) => void,
  mainLayout: string,
  subLayout: string,
  boostThemeLib: string,
  updateFieldReducer: (fieldName: string, data: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ProductItemTab extends Component<ComposedProps> {
  // componentDidMount() {
  //   const { boostThemeLib, updateFieldReducer } = this.props;
  //   if (boostThemeLib !== 'default') {
  //     updateFieldReducer('mainLayout', MAIN_LAYOUT_VALUE.MATCH_THEME);
  //   }
  // }

  getSubLayoutOptions = () => {
    const { i18n, mainLayout } = this.props;
    const options = (SUB_LAYOUT_OPTIONS[mainLayout] || []).map(item => ({
      ...item,
      label: i18n.translate(item.label)
    }));
    return options;
  };

  handleChangeMainLayout = (value: string) => {
    const { updateFieldReducer } = this.props;
    updateFieldReducer('mainLayout', value);
  };

  handleChangeSubLayout = (value: string) => {
    const { updateFieldReducer } = this.props;
    updateFieldReducer('subLayout', value);
  };

  render() {
    const {
      i18n,
      mainLayout: selectedMainLayout,
      subLayout: selectedSubLayout,
      boostThemeLib = 'default'
    } = this.props;

    const formattedMainLayout = MAIN_LAYOUT_OPTIONS.map(item => {
      return {
        ...item,
        label: i18n.translate(item.label)
      };
    });

    if (boostThemeLib !== 'default') {
      formattedMainLayout.push({
        label:
          i18n.translate('AdminHTML.ThemeSetting.LayoutModal.mainLayout_Option3') +
          ` (${capitalizeFirstLetter(boostThemeLib, 'en')} Theme)`,
        value: MAIN_LAYOUT_VALUE.MATCH_THEME
      });
    }

    const subLayoutOptions = this.getSubLayoutOptions();

    return (
      <div className="form-section">
        <div className="form-section__item">
          <div style={{ maxWidth: '46%' }}>
            <RenderSelect2
              name="mainLayout"
              value={selectedMainLayout}
              options={formattedMainLayout}
              label={i18n.translate('AdminHTML.ThemeSetting.LayoutModal.mainLayout_Item')}
              components={{ DropdownIndicator }}
              styles={styles}
              isSearchable={false}
              onChange={this.handleChangeMainLayout}
              menuPosition="fixed"
            />
          </div>

          {selectedMainLayout === MAIN_LAYOUT_VALUE.MATCH_THEME && (
            <div style={{ marginTop: '4px' }}>
              <TextStyle variation="subdued">
                {i18n.translate(
                  'AdminHTML.ThemeSetting.LayoutModal.mainLayout_Option3_Description'
                )}
              </TextStyle>
            </div>
          )}
        </div>
        {!!subLayoutOptions.length && (
          <div className="form-section__item" style={{ marginTop: '20px' }}>
            <Grid columns={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}>
              {subLayoutOptions.map((item, index) => {
                const Sample = item.sample;
                return (
                  <Grid.Cell key={index}>
                    <RenderRadioButtonItemV2
                      id={item.value}
                      value={item.value}
                      input={{
                        name: 'subLayout',
                        value: selectedSubLayout,
                        onChange: this.handleChangeSubLayout
                      }}
                      label={item.label}
                      helpText={<Sample checked={selectedSubLayout === item.value} />}
                    />
                  </Grid.Cell>
                );
              })}
            </Grid>
          </div>
        )}
      </div>
    );
  }
}

export default withI18n()(ProductItemTab);
